import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const FloatingCup = styled.img`
    position: absolute;
    right: 0;
    top: 50px;

    @media (max-width: 1024px) {
        display: none;
    }
`;

// Un consommateur doit pouvoir lire les CGV avant de payer.
export const SSalesTermsLink = styled(Link)`
    margin-top: 0.5rem;
    font-size: 1.2rem;
    text-decoration: underline;
`;

export const Cup = styled.img`
    @media (max-width: 500px) {
        display: none;
    }
`;
